function sanitizeFilenameSegment(text, maxLength = 80) {
    const cleaned = String(text || '')
        .trim()
        .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '')
        .replace(/\s+/g, ' ')
        .slice(0, maxLength);
    return cleaned;
}

/** Filesystem-safe export date (en-GB, dashes). */
export function formatExportPdfDate(date = new Date()) {
    try {
        const d = date instanceof Date ? date : new Date(date);
        if (Number.isNaN(d.getTime())) return '';
        return d
            .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            })
            .replace(/\//g, '-');
    } catch {
        return '';
    }
}

export const formatExportDate = formatExportPdfDate;

export function resolveExportProjectName(project) {
    if (!project || typeof project !== 'object') return 'Project';
    const name = project.project_name || project.name || '';
    return sanitizeFilenameSegment(name) || 'Project';
}

/**
 * Normalized download name: {Project name} {Label} [{Detail}] {Date}.{ext}
 */
export function buildExportFilename({
    extension = 'pdf',
    project,
    projectName,
    label,
    detail = '',
    date = new Date(),
} = {}) {
    const ext = String(extension || 'pdf').replace(/^\./, '').toLowerCase();
    const projectPart =
        sanitizeFilenameSegment(projectName) || resolveExportProjectName(project);
    const labelPart = sanitizeFilenameSegment(label, 60) || 'Export';
    const detailPart = sanitizeFilenameSegment(detail, 40);
    const datePart = formatExportPdfDate(date) || formatExportPdfDate(new Date());

    const parts = [projectPart, labelPart];
    if (detailPart) parts.push(detailPart);
    parts.push(datePart);

    return `${parts.join(' ')}.${ext}`;
}

export function buildExportPdfFilename(options = {}) {
    return buildExportFilename({ ...options, extension: 'pdf' });
}

export function buildExportCsvFilename(options = {}) {
    return buildExportFilename({ ...options, extension: 'csv' });
}

export function buildProjectCsvExportFilename(getState, { label, ids = null }) {
    const project = getState()?.projectData?.selectedProject;
    const detail = Array.isArray(ids) && ids.length > 0 ? `selected ${ids.length}` : '';
    return buildExportCsvFilename({ project, label, detail });
}

export function buildProjectCsvTemplateFilename(getState, label) {
    const project = getState()?.projectData?.selectedProject;
    return buildExportCsvFilename({ project, label, detail: 'template' });
}

/** @deprecated Use buildExportPdfFilename with label "Lens Intelligence". */
export function buildLensIntelligencePdfFilename(options = {}) {
    return buildExportPdfFilename({ ...options, label: 'Lens Intelligence' });
}

export const formatLensIntelligencePdfDate = formatExportPdfDate;
export const resolveLensIntelligenceProjectName = resolveExportProjectName;
